import Image01Retina from 'marketing-website/media/images/pages/features/design/photos/Image01@2x.jpg';
import Image02Retina from 'marketing-website/media/images/pages/features/design/photos/Image02@2x.jpg';
import Image03Retina from 'marketing-website/media/images/pages/features/design/photos/Image03@2x.jpg';
import Image04Retina from 'marketing-website/media/images/pages/features/design/photos/Image04@2x.jpg';
import Image05Retina from 'marketing-website/media/images/pages/features/design/photos/Image05@2x.jpg';
import Image06Retina from 'marketing-website/media/images/pages/features/design/photos/Image06@2x.jpg';
import Image07Retina from 'marketing-website/media/images/pages/features/design/photos/Image07@2x.jpg';
import Image08Retina from 'marketing-website/media/images/pages/features/design/photos/Image08@2x.jpg';
import Image09Retina from 'marketing-website/media/images/pages/features/design/photos/Image09@2x.jpg';
import Image10Retina from 'marketing-website/media/images/pages/features/design/photos/Image10@2x.jpg';
import Image11Retina from 'marketing-website/media/images/pages/features/design/photos/Image11@2x.jpg';
import Image12Retina from 'marketing-website/media/images/pages/features/design/photos/Image12@2x.jpg';

const stockPhotos = [
  {
    id: 0,
    src: Image01Retina,
    alt: '',
  },
  {
    id: 1,
    src: Image02Retina,
    alt: '',
  },
  {
    id: 2,
    src: Image03Retina,
    alt: '',
  },
  {
    id: 3,
    src: Image04Retina,
    alt: '',
  },
  {
    id: 4,
    src: Image05Retina,
    alt: '',
  },
  {
    id: 5,
    src: Image06Retina,
    alt: '',
  },
  {
    id: 6,
    src: Image07Retina,
    alt: '',
  },
  {
    id: 7,
    src: Image08Retina,
    alt: '',
  },
  {
    id: 8,
    src: Image09Retina,
    alt: '',
  },
  {
    id: 9,
    src: Image10Retina,
    alt: '',
  },
  {
    id: 10,
    src: Image11Retina,
    alt: '',
  },
  {
    id: 11,
    src: Image12Retina,
    alt: '',
  },
];

export default stockPhotos;



// WEBPACK FOOTER //
// ./src/configs/pages/features/design/photosOne.js